<template>
  <section class="core-promise">
    <div class="container">
      <div class="header-group reveal">
        <h2 class="section-title">Two Ways Bizzento Helps You Every Day</h2>
        <div class="accent-line"></div>
      </div>

      <div class="two-column">
        <div class="feature-column operations reveal slide-left">
          <div class="card-icon">⚡</div>
          <h3>The Hands: <span>Operations</span></h3>
          <p class="column-subtitle">
            Bizzento handles the repetitive "Busy Work" so you can reclaim your
            time.
          </p>

          <ul class="feature-list">
            <li class="reveal delay-1">
              <span class="dot"></span>
              <div>
                <strong>Virtual Assistant:</strong> Integrates with your site to
                guide shoppers.
              </div>
            </li>
            <li class="reveal delay-2">
              <span class="dot"></span>
              <div>
                <strong>24/7 Response:</strong> Answers inquiries, bookings, and
                FAQs instantly.
              </div>
            </li>
            <li class="reveal delay-3">
              <span class="dot"></span>
              <div>
                <strong>End-to-End Flow:</strong> Automates workflows from lead
                to loyalty.
              </div>
            </li>
          </ul>
        </div>

        <div class="feature-column strategy reveal slide-right">
          <div class="card-icon">🧠</div>
          <h3>The Brain: <span>Strategy</span></h3>
          <p class="column-subtitle">
            Bizzento analyzes the data to tell you exactly how to grow faster.
          </p>

          <ul class="feature-list">
            <li class="reveal delay-1">
              <span class="dot"></span>
              <div>
                <strong>Performance Insights:</strong> Visualizes what products
                are winning.
              </div>
            </li>
            <li class="reveal delay-2">
              <span class="dot"></span>
              <div>
                <strong>Growth Signals:</strong> Identifies untapped revenue
                opportunities.
              </div>
            </li>
            <li class="reveal delay-3">
              <span class="dot"></span>
              <div>
                <strong>Strategic Advising:</strong> Real-time suggestions to
                optimize your day.
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="footer-quote reveal delay-3">
        <div class="quote-box">
          <p class="tagline">"You decide. Bizzento executes and advises."</p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.core-promise {
  /* Theme Variables */
  --bg-warm-base: #f2eee0;
  --sunlight-glow: #faefca;
  --soft-gold: #f5e5b0;
  --dark-accent: #1a1a1a;
  --text-muted: #8e8a82;
  --gold-highlight: #d4af37;

  padding: 100px 24px;
  background-color: var(--bg-warm-base);
  color: var(--dark-accent);
  position: relative;
  overflow: hidden;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.header-group {
  text-align: center;
  margin-bottom: 80px;
}

.section-title {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 800;
  margin-bottom: 16px;
}

.accent-line {
  width: 80px;
  height: 4px;
  background: var(--soft-gold);
  margin: 0 auto;
  border-radius: 2px;
}

.two-column {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
  align-items: stretch;
}

.feature-column {
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  padding: 48px;
  border-radius: 32px;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.feature-column:hover {
  transform: translateY(-8px);
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.05);
}

.card-icon {
  font-size: 2.5rem;
  margin-bottom: 24px;
}

h3 {
  font-size: 1.8rem;
  margin-bottom: 12px;
}

h3 span {
  color: var(--gold-highlight);
}

.column-subtitle {
  color: var(--text-muted);
  font-size: 1.1rem;
  margin-bottom: 32px;
  line-height: 1.5;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-list li {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  font-size: 1rem;
  line-height: 1.5;
}

.dot {
  width: 8px;
  height: 8px;
  background: var(--soft-gold);
  border-radius: 50%;
  margin-top: 8px;
  flex-shrink: 0;
}

/* Quote Section */
.footer-quote {
  margin-top: 80px;
  text-align: center;
}

.quote-box {
  display: inline-block;
  padding: 24px 48px;
  border-radius: 100px;
  background: var(--sunlight-glow);
  border: 1px dashed var(--gold-highlight);
}

.tagline {
  font-size: 1.4rem;
  font-style: italic;
  font-weight: 600;
  margin: 0;
  color: var(--dark-accent);
}

@media (max-width: 768px) {
  .feature-column {
    padding: 32px;
  }
  .two-column {
    grid-template-columns: 1fr;
  }
}
</style>
<script>
export default {
  name: 'WhoWeAreSection',
  /*
  data() {
    return {
      image1: require("@/assets/images/abouts-1.jpg"),
      image2: require("@/assets/images/abouts-2.jpg"),
      graphic1: "https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Graphics/splash-4.svg",
      graphic2: "https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Graphics/tire-mark.svg",
      features: [
        "Daily Personal Activities & Assistance",
        "Travel & Transport Support",
        "Community & Social Participation",
        "Household Task Assistance",
        "Community Nursing Care"
      ]
    };
  }*/
};
</script>
